'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var InputBoxDoneTyping = function InputBoxDoneTyping(props) {
  var typingTimer = void 0;

  var handleOnChange = function handleOnChange(e) {
    if (props.onChange) {
      var value = e.target.value;
      props.onChange(value);
    }
  };

  var doneTyping = function doneTyping(value) {
    props.doneTyping(value);
  };

  var handleOnKeyUp = function handleOnKeyUp(e) {
    clearTimeout(typingTimer);
    var value = e.target.value;
    typingTimer = setTimeout(function () {
      doneTyping(value);
    }, props.doneTypingInterval);
  };

  var handleOnKeyDown = function handleOnKeyDown() {
    clearTimeout(typingTimer);
  };

  return _react2.default.createElement('input', {
    type: 'text',
    id: props.id,
    className: props.className,
    placeholder: props.placeholder,
    maxLength: props.maxLength,
    defaultValue: props.defaultValue,
    autoComplete: props.autoComplete,
    onChange: handleOnChange,
    onKeyUp: handleOnKeyUp,
    onKeyDown: handleOnKeyDown
  });
};

InputBoxDoneTyping.defaultProps = {
  autoComplete: 'on',
  doneTypingInterval: 500
};
InputBoxDoneTyping.propTypes = {
  id: _react.PropTypes.string,
  className: _react.PropTypes.string,
  placeholder: _react.PropTypes.string,
  maxLength: _react.PropTypes.number,
  defaultValue: _react.PropTypes.string,
  autoComplete: _react.PropTypes.oneOf(['on', 'off']),
  onChange: _react.PropTypes.func,
  doneTyping: _react.PropTypes.func.isRequired,
  doneTypingInterval: _react.PropTypes.number
};
exports.default = InputBoxDoneTyping;